/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import classNames from 'classnames';
import { Tag } from '../../../atoms/Tag/Tag';
import { Text } from '../../../atoms/Text/Text';
import { ChainStepBadge } from './components/ChainStepBadge';
import './AgentTransitionRendererStyles.scss';
const baseClass = 'qmb-ui-agent-transition-renderer';
export function AgentTransitionRenderer({ block }) {
    const transition = block;
    const fromName = transition.from_agent.display_name;
    const toName = transition.to_agent.display_name;
    return (React.createElement("div", { className: classNames(baseClass, { [`${baseClass}--nested`]: transition.nested }), role: "region", "aria-label": `Agent transition from ${fromName} to ${toName}` },
        React.createElement("div", { className: `${baseClass}__badges` },
            React.createElement(Tag, { label: transition.from_agent.display_name, icon: transition.from_agent.icon, variant: "gray", colorStyle: "solid", readOnly: true }),
            React.createElement("i", { className: `${baseClass}__arrow fa-light fa-arrow-right`, "aria-hidden": "true" }),
            React.createElement(Tag, { label: transition.to_agent.display_name, icon: transition.to_agent.icon, variant: "gray", colorStyle: "solid", readOnly: true })),
        React.createElement(Text, { variant: "body", className: `${baseClass}__message` }, transition.transition_message),
        transition.context_summary && (React.createElement(Text, { variant: "body", className: `${baseClass}__context` }, transition.context_summary)),
        React.createElement(ChainStepBadge, { step: transition.chain_step, total: transition.chain_total })));
}
